import ActionButton from 'components/ActionButton';
import React, { useState } from 'react';
import { createSupplier } from 'services/api/suppliers';
import { showError, showSuccess } from 'utils';
import styles from './index.module.scss';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers';
import { Error } from 'components/message/Error';

const validationSchema = yup.object().shape({
  name: yup.string().required(),
});

type FormData = {
  name: string;
  bankAccountNumber: string;
  bankRoutingNumber: string;
  address: string;
  email: string;
  phone: string;
};

const CreateSupplier = props => {
  const { register, handleSubmit, errors } = useForm<FormData>({ resolver: yupResolver(validationSchema) });

  const [loading, setLoading] = useState<boolean>(false);
  
  const createSupplierFn = handleSubmit(async ({
    address, bankAccountNumber, bankRoutingNumber, email, name, phone,
  }) => {
    setLoading(true);
    const supplierInfo = {
      name,
      email: email?.toLowerCase(),
      phone,
      bankAccountNo: bankAccountNumber,
      bankRoute: bankRoutingNumber,
      address,
    };
    
    try {
      const res = await createSupplier(supplierInfo);
      showSuccess('Supplier added successfully.');
      props.history.replace(`/suppliers/${res.id}`);
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  });
  
  return (
    <div className={styles['main-container']}>
      <div className={styles['header']}>
        <div className={styles['heading']}>Create a New Supplier</div>
      </div>
      <div className={styles['supplier-details']}>
        <div className={styles['name']}>
          <div className={styles['label']}>Name</div>
          <input
            name={'name'}
            ref={register}
            className={'form-control'}
            disabled={loading}
          />
          {errors.name && <Error message={errors.name.message} />}
        </div>
        <div className={styles['email']}>
          <div className={styles['label']}>Email</div>
          <input
            name={'email'}
            ref={register}
            className={'form-control'}
            disabled={loading}
          />
        </div>
        <div className={styles['phone']}>
          <div className={styles['label']}>Phone</div>
          <input
            name={'phone'}
            ref={register}
            className={'form-control'}
            disabled={loading}
          />
        </div>
        <div className={styles['bank-account-number']}>
          <div className={styles['label']}>Bank Account Number</div>
          <input
            name={'bankAccountNumber'}
            ref={register}
            className={'form-control'}
            disabled={loading}
          />
        </div>
        <div className={styles['bank-routing-number']}>
          <div className={styles['label']}>Bank Routing Number</div>
          <input
            name={'bankRoutingNumber'}
            ref={register}
            className={'form-control'}
            disabled={loading}
          />
        </div>
        <div className={styles['address']}>
          <div className={styles['label']}>Address</div>
          <textarea
            name={'address'}
            ref={register}
            className={'form-control'}
            disabled={loading}
          />
        </div>
      </div>
      <div className={styles['footer']}>
        <ActionButton
          text={'Cancel'}
          active={!loading}
          isLoading={false}
          onClick={() => props.history.goBack()}
          customClass={styles['cancel']}
        />
        <ActionButton
          text={'Create Supplier'}
          active={!loading}
          isLoading={loading}
          onClick={createSupplierFn}
        />
      </div>
    </div>
  );
};

export { CreateSupplier };
